import { ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  row: {
    display: 'flex',
    alignItems: 'stretch',
    gap: theme.marginBase * 2,

    [theme.media.tablet]: {
      flexDirection: 'column',
    },
  },
}));

export const SelectionRow = ({ children }: { children: ReactNode }) => {
  const classes = useStyles();
  return <div className={classes.row}>{children}</div>;
};
